import { t } from "i18next";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { DatePicker } from "../../../../ui/Datepicker/DatePicker";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ru from "date-fns/locale/ru";
import { maintenanceType } from "../../../../enums";
import { useFetch } from "../../../../hooks/useFetch";
import { Input } from "../../../../ui/Input/Input";
import { Label } from "../../../../ui/Label/Label";
import { SelectButton } from "../../../../ui/SelectButton/SelectButton";
import { Button } from "../../../../ui/Button";
import { DialogClose } from "../../../../ui/Dialog";
import { Textarea } from "../../../../ui/TextArea/Textarea";
import { ScrollArea } from "../../../../ui/ScrollArea/ScrollArea";
registerLocale("es", ru);

type Props = {
  equipmentId: string;
  updateList: Function;
  closeModal: Function;
};

const AddMaintenance = ({ equipmentId, updateList, closeModal }: Props) => {
  const maintenanceTypes = maintenanceType.map((type) => ({
    label: t(`maintenance_${type}`),
    value: type,
  }));
  const [open, setOpen] = React.useState(false);
  const [errors, setErrors] = useState([]);
  const { reset, handleSubmit, control } = useForm({
    defaultValues: {
      maintenance_name: "",
      maintenance_type: { value: "", label: "" },
      maintenance_time: "",
      maintenance_previous_date: null,
      maintenance_description: "",
    },
  });

  const [
    { response: saveResponse, isLoading: saveIsLoading, error: saveError },
    doFetchItemSave,
  ] = useFetch(`/directories/equipment_items/${equipmentId}/maintenances`);

  // Обновление списка эксплуатаций при получении ответа и закрытие формы
  useEffect(() => {
    if (saveResponse) {
      updateList();
      reset();
      closeModal();
    }
  }, [saveResponse]);

  const onSubmit = (formData: any) => {
    doFetchItemSave({
      method: "POST",
      data: {
        data: {
          previous_maintenance_at:
            formData.maintenance_previous_date || new Date(),
          description: formData.maintenance_name || null,
          maintenance_time: formData.maintenance_time || null,
          maintenance_type: formData.maintenance_type.value,
          maintenance_description: formData.maintenance_description || "",
        },
      },
    });
  };

  // Очистка формы при открытии
  useEffect(() => {
    reset();
  }, [open]);

  return (
    <ScrollArea className="w-full">
      <div className="flex flex-col w-full">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex flex-col w-full pt-8 h-full gap-3">
            <Controller
              name="maintenance_name"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <div className="relative space-y-2">
                  <Input {...field} label={`${t("maintenance_name")}*`} />
                </div>
              )}
            />
            <Controller
              name="maintenance_type"
              control={control}
              rules={{ required: true }}
              render={({ field: { value, onChange } }) => (
                <div className="relative space-y-2">
                  <Label>{t("maintenance_type")}*</Label>
                  <SelectButton
                    label={"choose_maintenance_type"}
                    searchable={false}
                    options={maintenanceTypes}
                    value={
                      value
                        ? maintenanceTypes?.find(
                            (s) => s.value == String(value),
                          )!
                        : null
                    }
                    onChange={(e) => onChange(e?.value)}
                  />
                </div>
              )}
            />
            <Controller
              name="maintenance_time"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <div className="relative space-y-2">
                  <Input {...field} label={`${t("maintenance_time")}*`} />
                </div>
              )}
            />
            <Controller
              name="maintenance_previous_date"
              control={control}
              rules={{ required: true }}
              render={({ field: { value, onChange } }) => (
                <div className="relative space-y-2">
                  <Label>{t("maintenance_previous_date")}</Label>
                  <DatePicker
                    mode="single"
                    algin="start"
                    selected={value!}
                    onSelect={onChange}
                  />
                </div>
              )}
            />
            <Controller
              name="maintenance_description"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <div className="relative space-y-2">
                  <Label>{t("maintenance_description")}*</Label>
                  <Textarea {...field} />
                </div>
              )}
            />
            <div className="flex justify-between items-center">
              <DialogClose>
                <Button variant={"secondary"}>{t("cancel")}</Button>
              </DialogClose>

              <Button type="submit">{t("save")}</Button>
            </div>
          </div>
        </form>
      </div>
    </ScrollArea>
  );
};

export default AddMaintenance;
